<checkout-cms-block [blockId]="choicesByType[type]" [battlefront]="false" [addIndexHtmlToUrl]="false" />
